export default "__VITE_ASSET__opNBnIhZ__"